import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Button } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';
import classnames from 'classnames';

import styles from './styles/buttonSwitch';

const useStyles = createUseStyles(styles, 'OperationSwitch');

const OperationSwitch = ({ onChange, value }) => {
    const { t } = useWeb5Context();
    const classes = useStyles();

    const rootClassName = classnames(classes.root);

    const buttons = useMemo(
        () => [
            {
                label: t('cfm_label_condition_and'),
                value: 'and',
            },
            {
                label: t('cfm_label_condition_or'),
                value: 'or',
            },
        ],
        [t],
    );

    const buttonsEl = useMemo(
        () =>
            buttons.map((button) => {
                const buttonClassName = classnames(classes.button, {
                    [classes.active]: button.value === value,
                });
                return (
                    <Button
                        key={button.value}
                        type="terciary"
                        className={buttonClassName}
                        onClick={() => onChange && onChange(button.value)}
                    >
                        {button.label}
                    </Button>
                );
            }),
        [buttons, classes.active, classes.button, onChange, value],
    );

    return <div className={rootClassName}>{buttonsEl}</div>;
};

OperationSwitch.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.any,
};

export default memo(OperationSwitch);
